import React, { Component } from 'react'
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import Principal from "../../components/Cotizacion/Principal";
import { FetchSetDashboard } from "../../redux/actions/aCotizacion";
import { ambienteAplicacion } from "../../constants/urls";



class ContainerPrincipal extends Component {

  async componentDidMount() {
    await this.props.setDashboard(this.props.datosUsuario.dataUsuario.cliCodigoCore,ambienteAplicacion);
    }

  render() {
    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            <Principal />
          </div>
        </div>
      </main>
    )
  }
}

const mapStateToProps = state => ({
  datosDashboard: state.datosDashboard,
  datosUsuario: state.datosUsuarios
});

const mapDispatchToProps = dispatch => {
  return {
    setDashboard: (param,ambienteAplicacion) => dispatch(FetchSetDashboard(param,ambienteAplicacion)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerPrincipal)
);
